var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1177"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1177"
    },
    "bundlingPackage": "marketplace-storefront-public-ui",
    "bundlingPackageVersion": "static-1.12676",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};